module.exports = __webpack_public_path__ + "img/gis-sql.6483632f.svg";